module.exports = __webpack_public_path__ + "img/header-5.84e7fe5b.png";